<template>
  <div>
    <v-expansion-panels class="rounded-card" multiple focusable>
      <v-expansion-panel
        active-class="rounded-card"
        v-for="produto in cotacao.produtos"
        :key="produto.id"
      >
        <v-expansion-panel-header>
          <v-row dense align="center">
            <v-col cols="12" sm="1">
              <px-span-tooltip top :text="produto.id" tooltip="Código do item"/>
            </v-col>
            <v-col cols="12" sm="10" class="text-truncate">
              <px-produto-descricao :show-codigo="false"
                                    :especificacao="produto.especificacaoProduto"
                                    :produto="produto.produto"/>
          <px-span-tooltip top :text="quantidadeText(produto)"
                               tooltip="Quantidade"/>
              <px-situacao-cotacao-icon :situacao="produto.situacao"/>
              <div class="caption">
                {{ produto.especificacaoProduto | truncate(75) }}
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <px-cotacao-resposta-view-produto-fornecedores :search-text="searchText"
                                                         :selected-sort="selectedSort"
                                                         :cotacao-produto="produto"
                                                         :cotacao-id="cotacaoId"
                                                         :is-modal-view="isModalView"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import Vue from 'vue';
import CotacaoRespostaViewProdutoFornecedores from './CotacaoRespostaViewProdutoFornecedores.vue';

export default {
  props: {
    searchText: String,
    selectedSort: Object,
    cotacaoId: {
      type: [String, Number],
      required: true,
    },
    cotacao: {
      type: Object,
    },
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      respostas: [1, 2, 3],
    };
  },
  computed: {
    quantidadeText() {
      return produto => `(${Vue.filter('number')(produto.quantidade, '0.00')} ${produto.unidadeMedida.descricao})`;
    },
  },
  components: {
    pxCotacaoRespostaViewProdutoFornecedores: CotacaoRespostaViewProdutoFornecedores,
  },
};
</script>
